import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
// import FJConfig from '../../config/FJConfig';
import {
    updateAnimationDuration,
    updateAnimationType,
    updateDirectionType,
    updateIntensity,
    updateIsReverse,
    updateLoop,
} from '../../store/FJFake3dStore';
import { ANIMATION_STYLE_LIST } from '../../config/dataConfig/FJFake3dData';
import FJFake3dExportStore from '../../store/FJFake3dExportStore';

const FJSliceFake3d = createSlice({
    name: 'fake3d',
    initialState: {
        uploadStatus: FJConstant.DEFAULT,
        // originImage: {
        //     src: FJConfig.imgPath + '/fake3d/ball.jpg',
        //     width: 1600,
        //     height: 1067,
        // },
        // deepMapImage: {
        //     src: FJConfig.imgPath + '/fake3d/ball-map.jpg',
        //     width: 1600,
        //     height: 1067,
        // },

        previewImage: {},
        originImage: {},
        deepMapImage: {},
        viewSize: {},
        animationStyle: ANIMATION_STYLE_LIST[0].type,
        direction: ANIMATION_STYLE_LIST[0].directions[0].type,
        intensity: 50,
        duration: 4,
        returnAnimation: true,
        reverse: false,
        exportFormate: 'video',
        exportResolution: '1080',
        exportProgress: 0,
        settingStep: FJConstant.DEFAULT,
    },

    reducers: {
        setVewSize: (state, action) => {
            state.viewSize = action.payload;
        },
        setUploadStatus: (state, action) => {
            state.uploadStatus = action.payload;
        },
        setOriginImage: (state, action) => {
            state.originImage = action.payload;
        },
        setPreviewImage: (state, action) => {
            state.previewImage = action.payload;
        },
        setDeepMapImage: (state, action) => {
            state.deepMapImage = action.payload;
        },
        setAnimationStyle: (state, action) => {
            state.animationStyle = action.payload;
            updateAnimationType(action.payload);
        },
        setDirection: (state, action) => {
            state.direction = action.payload;
            updateDirectionType(action.payload);
        },
        setIntensity: (state, action) => {
            state.intensity = action.payload;
            updateIntensity(action.payload);
        },
        setDuration: (state, action) => {
            state.duration = action.payload;
            updateAnimationDuration(action.payload);
        },
        setReturnAnimation: (state, action) => {
            state.returnAnimation = action.payload;
            updateLoop(action.payload);
        },
        setReverse: (state, action) => {
            state.reverse = action.payload;
            updateIsReverse(action.payload);
        },
        setExportFormate: (state, action) => {
            state.exportFormate = action.payload;
        },
        setExportResolution: (state, action) => {
            state.exportResolution = action.payload;
            FJFake3dExportStore.updateViewSizeByResolution(action.payload);
        },
        setSettingStep: (state, action) => {
            state.settingStep = action.payload;
        },
        setExportProgress: (state, action) => {
            state.exportProgress = action.payload;
        },
    },
});

export const {
    setOriginImage,
    setDeepMapImage,
    setAnimationStyle,
    setDirection,
    setIntensity,
    setDuration,
    setReturnAnimation,
    setReverse,
    setExportFormate,
    setExportResolution,
    setSettingStep,
    setUploadStatus,
    setVewSize,
    setExportProgress,
    setPreviewImage,
} = FJSliceFake3d.actions;

export default FJSliceFake3d.reducer;
